export default __webpack_public_path__ + "static/media/52_photo.b168c787.jpg";